export var ExecutionDetailsSourceEnum;
(function (ExecutionDetailsSourceEnum) {
    ExecutionDetailsSourceEnum["CREDENTIALS"] = "Credentials";
    ExecutionDetailsSourceEnum["INTERNAL"] = "Internal";
    ExecutionDetailsSourceEnum["PAYLOAD"] = "Payload";
    ExecutionDetailsSourceEnum["WEBHOOK"] = "Webhook";
})(ExecutionDetailsSourceEnum || (ExecutionDetailsSourceEnum = {}));
export var ExecutionDetailsStatusEnum;
(function (ExecutionDetailsStatusEnum) {
    ExecutionDetailsStatusEnum["SUCCESS"] = "Success";
    ExecutionDetailsStatusEnum["WARNING"] = "Warning";
    ExecutionDetailsStatusEnum["FAILED"] = "Failed";
    ExecutionDetailsStatusEnum["PENDING"] = "Pending";
    ExecutionDetailsStatusEnum["QUEUED"] = "Queued";
    ExecutionDetailsStatusEnum["READ_CONFIRMATION"] = "ReadConfirmation";
})(ExecutionDetailsStatusEnum || (ExecutionDetailsStatusEnum = {}));
//# sourceMappingURL=execution-details.interface.js.map